import { Observable } from "rxjs";
import {
  CommunityPlayer,
  CommunityPlayerSortBy,
} from "@app/core/community/domain/model/community-player";

export interface CommunityPlayersQuery {
  search?: string | null;
  page?: number;
  /** Backend defaults to 20 and caps at 100. */
  pageSize?: number;
  /** Not yet supported by the backend, see CommunityPlayerSortBy. */
  sortBy?: CommunityPlayerSortBy | null;
}

export interface CommunityPlayersPage {
  players: CommunityPlayer[];
  total: number;
}

export abstract class CommunityPlayersRepo {
  abstract getPlayers(
    query: CommunityPlayersQuery
  ): Observable<CommunityPlayersPage>;
}
